// extracted by mini-css-extract-plugin
module.exports = {"adminContent":"Layout_adminContent__3y6WH"};